const Notification = {
  state: {
    listNotifications: [],
    soundMessage: false,
    soundGoal: false,
    soundSilence: false
  },
  actions: {
    addNotification({commit} , notification) {
      commit('addNotification', notification)
    },
    removeNotification({commit}, indexNotification) {
      commit('removeNotification', indexNotification)
    },
    soundMessage({commit}) {
      commit('changeSoundMessage', true)
      setTimeout(() => {
        commit('changeSoundMessage', false)
      }, 3000)
    },
    soundGoal({commit}) {
      commit('changeSoundGoal', true)
      setTimeout(() => {
        commit('changeSoundGoal', false)
      }, 5000)
    },
    soundGoalPlay({commit}) {
      commit('changeSoundGoal', true)
    },
    soundGoalStop({commit}) {
      commit('changeSoundGoal', false)
    },
    soundSilence({commit}) {
      commit('changeSoundSilence', true)
      setTimeout(() => {
        commit('changeSoundSilence', false)
      }, 3000)
    },
  },
  mutations: {
    addNotification(state, notification) {
      state.listNotifications.push(notification)
    },
    removeNotification(state, indexNotification) {
      state.listNotifications.splice(indexNotification, 1)
    },
    changeSoundMessage(state, activeSoundMessage) {
      state.soundMessage = activeSoundMessage
    },
    changeSoundGoal(state, activeSoundGoal) {
      state.soundGoal = activeSoundGoal
    },
    changeSoundSilence(state, activeSoundSilence) {
      state.soundSilence = activeSoundSilence
    }
  }
}

export default Notification;

// .dispatch('addNotification', {
//   value: 'request_info',
//   status: 'success' 
// })